<template>
  <div>
<!--    <el-card class="card">-->
        <div class="card">
          <el-form :model="dataForm"  ref="dataForm"  label-width="80px">
            <el-form-item label="标题">
              <el-input v-model="dataForm.title" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="欢迎语句">
              <el-input v-model="dataForm.welcome" maxlength="150"></el-input>
            </el-form-item>
            <el-form-item label="默认语句" >
              <el-input v-model="dataForm.defual" maxlength="150"></el-input>
            </el-form-item>
            <el-form-item label="已用Logo">
              <el-input v-model="dataForm.img" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="Logo上传" prop="newPassword">
                    <el-upload
                      class="upload-demo"
                      style="text-align: left"
                      action=""
                      :on-change="handleChange"
                      :on-remove="handleRemove"
                      :limit="1"
                      :accept="acceptFileType"
                      :file-list="fileList"
                      :http-request="getFile"
                      >
                      <el-button  type="primary">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
                    </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="confirmSubmit" style="float: left;width: 100px" :loading="isLoading">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
<!--    </el-card>-->
  </div>
</template>

<script>
import {uploadImg, post, getQAList} from '@/api/common'
export default {
  name: 'globaconfig',
  data () {
    return {
      file: {},
      fileList: [],
      dataForm: {
        id: '',
        title: '',
        welcome: '',
        defual: '',
        img: ''
      },
      acceptFileType: '.png,.jpe',
      caption: 'word_config', // 数据库中存储自定义信息的键值
      isLoading: false,
      imgPath: ''

    }
  },
  created () {
    this.userId = localStorage.getItem('userId')
    this.tableHeight = window.innerHeight - 352 + 'px'
    window.onresize = () => {
      return (() => {
        this.tableHeight = window.innerHeight - 352 + 'px'
      })()
    }
    this.init()
  },
  methods: {
    init () {
      let params = {
        col: this.caption
      }
      getQAList('config/select', params).then((resp) => {
        if (resp.data.code === 0) {
          if (resp.data.data != null) {
            this.dataForm.id = resp.data.data.id
            let result = resp.data.data.content
            let json = JSON.parse(result)
            this.dataForm.welcome = json.welcomeWord
            this.dataForm.title = json.title
            this.dataForm.defual = json.defualWord
            this.dataForm.img = json.img
            this.imgPath = json.logoImgUrl
          }
        } else {
          this.$notify({
            title: '提示',
            message: '获取数据报错，请重试',
            type: 'warning'
          })
          return false
        }
      }).catch(response => {
        this.$notify({
          title: '提示',
          message: '获取数据失败，请重新',
          type: 'warning'
        })
      })
    },
    resetForm (formName) {
      this.fileList = []
      this.$refs['dataForm'].resetFields()
    },
    beforeUpload (file) {
      this.fileList.push(file)
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'

      const isLt2M = file.size / 1024 / 1024 < 10
      if (!isJPG && !isPNG) {
        this.$notify({
          title: '提示',
          message: '上传图片只能是 png/jpg 格式!',
          type: 'warning'
        })
        return
      }
      if (!isLt2M) {
        this.$notify({
          title: '提示',
          message: '上传图片大小不能超过 10MB!',
          type: 'warning'
        })
        return
      }
      this.fileName = file.name
      return isJPG && isPNG && isLt2M
    },
    confirmSubmit (evt) {
      this.$confirm('是否保存？请确认', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.onSubmit(evt)
      }).catch()
    },
    onSubmit (evt) {
      this.isLoading = true
      let target = evt.target
      // 根据button组件内容 里面包括一个span标签，如果设置icon，则还包括一个i标签，其他情况请自行观察。
      // 所以，在我们点击到button组件上的文字也就是span标签上时，直接执行e.target.blur()不会生效，所以要加一层判断。
      if (target.nodeName === 'SPAN' || target.nodeName === 'I') {
        target = evt.target.parentNode
      }
      target.blur()
      let params = {}
      params.welcomeWord = this.dataForm.welcome
      params.defualWord = this.dataForm.defual
      params.caption = this.caption
      params.title = this.dataForm.title
      params.id = this.dataForm.id

      const formData = new FormData()

      formData.append('file', this.file)

      // const config = {headers: {'Content-Type': 'multipart/form-data'}}

      if (this.fileList.length === 0) {
        params.logoImgUrl = this.imgPath
        params.img = this.dataForm.img
        // 先上传图片，上传后返回图片地址
        post('config/save', params).then((resp) => {
          this.isLoading = false
          if (resp.data.ret === 1) {
            this.$notify({
              title: '提示',
              message: resp.data.message,
              type: 'success'
            })
            this.resetForm(this.dataForm)
          } else {
            this.$notify({
              title: '提示',
              message: '保存失败，请重试',
              type: 'warning'
            })
            return false
          }
          this.init()
        }).catch(response => {
          this.isLoading = false
          this.$notify({
            title: '提示',
            message: '保存失败，请重试',
            type: 'warning'
          })
        })
      } else {
        uploadImg('uploadImg/uploadFile', formData).then((resp) => {
          this.isLoading = false
          if (resp.data.ret === 1) {
            // 获取图片地址
            params.logoImgUrl = resp.data.content.imgpath
            params.img = resp.data.content.img
            // 将图片地址插入到数据库
            post('config/save', params).then((resp) => {
              if (resp.data.ret === 1) {
                this.$notify({
                  title: '提示',
                  message: resp.data.message,
                  type: 'success'
                })
                this.resetForm(this.dataForm)
              } else {
                this.$notify({
                  title: '提示',
                  message: '保存失败，请重试',
                  type: 'warning'
                })
                return false
              }
              this.init()
            }).catch(response => {
              this.$notify({
                title: '提示',
                message: '保存失败，请重试',
                type: 'warning'
              })
            })
          } else {
            this.$notify({
              title: '提示',
              message: '图片上传失败，请重试',
              type: 'warning'
            })
          }
        }).catch(response => {
          this.isLoading = false
          this.$notify({
            title: '提示',
            message: '图片上传失败，请重试',
            type: 'warning'
          })
        })
      }
    },

    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      this.fileList.push(file)
    },
    beforeRemove (file, fileList) {
      // return this.$confirm(`确定移除 ${file.name}？`)
    },
    handleChange (file, fileList) {
      this.fileList = fileList.slice(-1)
    },
    getFile (item) {
      this.file = item.file
    }
  }
}
</script>

<style scoped>
  .card{
    width: 40%;
    padding: 20px;
    height: 470px;
    /*margin: 0 auto;*/
    /*position: absolute;*/
    /*top: 50%;*/
    /*left: 50%;*/
    /*margin-left: -20%;*/
    /*margin-top: -200px;*/
    /*transform: translate(-50% -50%);*/
  }

</style>



// WEBPACK FOOTER //
// src/views/services/globaconfig.vue